import { getPageIdInfo, loadJS } from "../../utils/common";
import { zzsdk } from "../../utils/initLoadSdk";
var setClostMarkByPageId = function setClostMarkByPageId() {
  var pageInfo = getPageIdInfo();
  var pageId = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.pageId;
  if (!pageId) return;
  var setCloseMark = function setCloseMark() {
    try {
      window.__ZZAPP__.hasSupportFeature({
        method: 'addCloseMark'
      }, function (res) {
        if (res && res.code === '1') {
          window.__ZZAPP__.run('addCloseMark', {
            mark: pageId
          }, function () {});
        } else {
          window.__ZZAPP__['setCloseMark']({
            mark: pageId
          });
        }
      });
    } catch (error) {
      window.__ZZAPP__['setCloseMark']({
        mark: pageId
      });
    }
  };
  if (window.__ZZAPP__) {
    setCloseMark();
  } else {
    loadJS(zzsdk, function () {
      setCloseMark();
    });
  }
};
export default setClostMarkByPageId;